import { useState } from "react";
import { useGetProductPublic } from "../../features/product";
import { useCreateTransactionPublic } from "../../features/transaction";
import { toast } from "react-toastify";

const HifiairForm = () => {
  const allowedPrefixes = ["62895", "62896"];

  const [formData, setFormData] = useState({
    hifiNumber: "",
    hifiProductId: "",
    customerName: "",
    customerEmail: "",
    whatsappNumber: "",
  });

  const [hifiPrefix, setHifiPrefix] = useState("62895");

  const { product } = useGetProductPublic();
  const { transaction: Create } = useCreateTransactionPublic();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    const selectedProduct = product?.find((prod) => prod.id === selectedId);
    if (selectedProduct) {
      setFormData({ ...formData, hifiProductId: selectedProduct.id });
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!allowedPrefixes.includes(hifiPrefix)) {
      toast.warning("Prefix nomor Hifi harus 62895 atau 62896");
      return;
    }

    const finalPayload = {
      hifiNumber: hifiPrefix + formData.hifiNumber,
      whatsappNumber: formData.whatsappNumber,
      hifiProductId: formData.hifiProductId,
      customerName: formData.customerName,
      customerEmail: formData.customerEmail,
    };

    Create(finalPayload, {
      onSuccess: () => {
        setFormData({
          hifiNumber: "",
          hifiProductId: "",
          customerName: "",
          customerEmail: "",
          whatsappNumber: "",
        });
        setHifiPrefix("62895");
      },
    });
  };

  return (
    <div className="max-w-lg mx-auto p-8 bg-white rounded-lg">
      <h1 className="text-2xl font-semibold text-center mb-6 text-gray-800">
        Create Transaction
      </h1>
      <form onSubmit={handleSubmit} className="space-y-5">
        {/* HIFI Number */}
        <div className="flex items-start gap-3 p-4 bg-yellow-50 border border-yellow-200 rounded-md">
          <div className="text-yellow-600 mt-0.5">⚠️</div>
          <div className="text-sm text-yellow-800">
            <p className="font-semibold">Perhatian</p>
            <p>
              Paket Data Hifi Air hanya berlaku untuk nomor{" "}
              <span className="font-medium">Tri</span> dan tidak berlaku untuk
              nomor <span className="font-medium">IM3</span>.
            </p>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nomor Hifi
          </label>
          <div className="flex gap-3">
            <select
              value={hifiPrefix}
              onChange={(e) => setHifiPrefix(e.target.value)}
              className="w-1/3 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            >
              {allowedPrefixes.map((prefix) => (
                <option key={prefix} value={prefix}>
                  {prefix}
                </option>
              ))}
            </select>
            <input
              type="number"
              name="hifiNumber"
              value={formData.hifiNumber}
              onChange={handleChange}
              placeholder="Masukkan nomor"
              className="w-2/3 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>
        </div>

        {/* Produk */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Produk
          </label>
          <select
            name="hifiProductId"
            value={formData.hifiProductId}
            onChange={handleSelectProduct}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          >
            <option value="">Pilih Produk</option>
            {product?.map((prod) => (
              <option key={prod.code} value={prod.id}>
                {prod.name} - Rp {prod.price.toLocaleString("id-ID")}
              </option>
            ))}
          </select>
        </div>

        {/* Nama */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nama Customer
          </label>
          <input
            type="text"
            name="customerName"
            value={formData.customerName}
            onChange={handleChange}
            placeholder="Masukkan Nama Customer"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            required
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email Customer
          </label>
          <input
            type="email"
            name="customerEmail"
            value={formData.customerEmail}
            onChange={handleChange}
            placeholder="Masukkan Email Customer "
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          />
        </div>

        {/* Whatsapp (bebas) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nomor Whatsapp
          </label>
          <input
            type="number"
            name="whatsappNumber"
            value={formData.whatsappNumber}
            onChange={handleChange}
            placeholder="Masukkan Nomor Whatsapp"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            required
          />
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="w-full mt-6 py-3 bg-[#CC0090] text-white font-semibold rounded-md hover:bg-[#b30080] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#CC0090]"
        >
          Checkout
        </button>
      </form>
    </div>
  );
};

export default HifiairForm;
